import { FC, useContext } from 'react';

import { Separator, Toggle } from '@smartshell/ui-kit';

import { TimeOutInput } from 'components';
import { LocalizationContext } from 'localization';
import { ESettingsAliases, SettingsContext } from 'settings';

export const TurningOffPC: FC = () => {
  const { t } = useContext(LocalizationContext);
  const {
    state: { settings },
    actions: { setSetting },
  } = useContext(SettingsContext);

  return (
    <>
      <Toggle
        onChange={(value: boolean) =>
          setSetting({
            alias: ESettingsAliases.AUTO_TURNOFF_ENABLED,
            value: value ? '1' : '0',
          })
        }
        value={settings.autoTurnoffEnabled}
        label={t('setting.shell.shutdown')}
        description={t('settings.shell.power_manager.off_pc.description')}
        emptyBg
        variant="secondary"
      />
      <Separator style={{ margin: '16px 0' }} />
      <TimeOutInput
        label={t('settings.shell.power_manager.timeout.title')}
        description={t('settings.shell.power_manager.timeout.description')}
        setting={settings.autoTurnoffTimeout}
        updateSetting={setSetting}
        settingAlias={ESettingsAliases.AUTO_TURNOFF_TIMEOUT}
        inMinutes
        disabled={settings.autoTurnoffEnabled}
      />
    </>
  );
};
